import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { beUserInfo } from 'actions/fetchUserInfo.action';
import buildCapitalSessionPayloads from 'bl/capital/buildCapitalSessionPayloads.bl';
import STRIPE_STATUS from 'constants/stripeStatus.const';
import { usePrepareReadOnly } from 'hooks/usePrepare.hook';
import { selectAccessSalonId, selectAccessStylistId, selectAccessUserId } from 'selectors/access.selectors';
import { selectCurrentSalon, selectCurrentSalonStripeStatus } from 'selectors/currentSalon.selectors';
import { isEffectiveManager, isEffectiveReceptionist } from 'selectors/user';

export const useStripeCapitalPayloads = () => {
  const currentSalon = useSelector(selectCurrentSalon);
  const stripeStatus = useSelector(selectCurrentSalonStripeStatus);
  const accessSalonId = useSelector(selectAccessSalonId);
  const stylistId = useSelector(selectAccessStylistId);
  const userId = useSelector(selectAccessUserId);
  const manager = useSelector(isEffectiveManager);
  const receptionist = useSelector(isEffectiveReceptionist);

  const salonId = currentSalon?.id ?? accessSalonId ?? null;

  const { qj, isLoading, isError } = usePrepareReadOnly(beUserInfo);

  const stripeAccountId = qj?.stripe_account_id ?? null;
  const hasFetched = !isLoading;

  const salonHasStripe = !!currentSalon?.has_ncob_stripe_account || (!!stripeStatus && stripeStatus !== STRIPE_STATUS.noAccount);

  const hasStripeRelationship = hasFetched ? !!stripeAccountId || (isError && salonHasStripe) : false;

  const payloads = useMemo(() => {
    if (!hasFetched) return [];

    return buildCapitalSessionPayloads({
      salonId,
      stylistId,
      userId,
      isManager: manager,
      isReceptionist: receptionist,
    });
  }, [salonId, stylistId, userId, manager, receptionist, hasFetched]);

  return { payloads, salonId, merchantId: stripeAccountId, hasStripeRelationship };
};
